module.exports = __webpack_public_path__ + "static/media/black-and-white-close-up-dark-167964.edc96619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/header/assets/black-and-white-close-up-dark-167964.jpg
// module id = 1072
// module chunks = 0